import { Injectable } from "@angular/core";
import "rxjs/add/operator/toPromise";
import { AngularFireAuth } from "angularfire2/auth";
import { FirebaseService } from "./firebase.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IUserSubData } from "../models/userData";

@Injectable()
export class AuthService {
  constructor(private afAuth: AngularFireAuth,private Firervc: FirebaseService) {}

  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.createUserWithEmailAndPassword(value.email, value.password).then(res => resolve(res), err => reject(err));
    });
  }

  doLogin(value) {
    // console.log(value.mail)
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(value.email, value.password).then(res => resolve(res), err => reject(err));
    });
  }

  doResetPassword(value) {
    //console.log(value);
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.sendPasswordResetEmail(value).then(res => resolve(res), err => reject(err));
    });
  }

  doLogout() {
    return new Promise((resolve, reject) => {
      if (this.afAuth.auth.currentUser) {
        this.afAuth.auth
          .signOut()
          .then(() => {
            // this.firebaseService.unsubscribeOnLogOut();
            resolve();
          })
          .catch(error => {
            reject();
          });
      }
    });
  }

  doSubscribe(): Observable<IUserSubData[]> {

   return this.Firervc.GetUserData().pipe(
      map((res: IUserSubData[]) => {
        //Salva nella local storage i dati di subscription
     //   localStorage.setItem("UserDataSubscription", JSON.stringify(res));
        return res;
      })
    );
  }

  doSendEmailConferm(){
    console.log();
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.currentUser.sendEmailVerification().then(res => resolve(res), err => reject(err));
    });
}

}



// WEBPACK FOOTER //
// ./src/services/auth.service.ts